module.exports = __webpack_public_path__ + "static/media/star-empty.25c1d572.svg";